import React, { useEffect, useState } from "react";
import { CustomDialog } from "../../../../CustomDialog";
import { useTranslate } from "../../../../../../Hooks";
import UnitsAddForRentView from "./UnitsAddForRentView";
import UnitsAddForSaleView from "./UnitsAddForSaleView";
import { CustomButton } from "../../../../CustomButton";
import { useVerticalNav } from "../../../../../../Contexts/VerticalNavContext";

//styles
import useStyles from "./styles";

const UnitSucsessValidateDialog = ({ open, onClose }) => {
  const styles = useStyles();
  const { translate } = useTranslate("HeaderView");
  const [view, setview] = useState(1);

  const [onSaveCall, setOnSaveCall] = useState(false);
  const [onSaveAndCompleteCall, setOnSaveAndCompleteCall] = useState(false);
  const { addNewUnit } = useVerticalNav();
  const [saveDtoSale, setSaveDtoSale] = useState({
    unit_ref_no: null,
    selling_price_agency_fee: {
      salePrice: 0,
      agencyFee: 0,
      persantageFee: 0,
    },
    unit_type_id: 1,
    operation_type: {
      lookupItemId: 430,
      lookupItemName: "Sale",
      lookupItemCode: null,
      description: null,
      order: 1,
      parentLookupItemId: null,
      parentLookupItemName: null,
      parentLookupTypeId: 0,
      parentLookupTypeName: null,
      isEditable: false,
    },
    new_unit: "Yes",
    unit_type: null,
    furnished: "No",
    property_name: null,
    owner: null,
    lead_owner: null,
    floor_number: null,
    mandates: null,
    mandate_type: null,
    unit_number: null,
    mortgaged: null,
    can_view: null,
    unique_selling_proposition_usp: null,
    municipality_number: null,
    ejari_approval_refno: null,
    inventory_list_from: null,
    website_unit_link: null,
    fully_unit_description: null,
    unit_model: null,
    full_floor: null,
    bedrooms: null,
    bathrooms: null,
    maid_rooms: null,
    store_room: null,
    study_room: null,
    kids_breakfast_room: null,
    kitchen_details: null,
    number_of_balcony: null,
    number_of_terraces: null,
    floor_height: null,
    plot_area_sqft: null,
    builtup_area_sqft: null,
    gfa_sqft: null,
    balcony_area_size_sqft: null,
    terrace_size_sqft: null,
    total_area_size_sqft: null,
    price_per_sqm: null,
    amenities: null,
    fitting_and_fixtures: null,
    primary_view: null,
    secondary_view: null,
    pets_allowed: null,
    rating: null,
    listing_agent: null,
    listing_date: null,
    listing_expiry_period: null,
    listing_expiry_date: null,
    last_available_for_rent: null,
    market_value_rent: null,
    rent_security_deposit: null,
    rent_general_deposit: null,
    chiller_charge_type: null,
    chiller_charge_for_rent_unit: null,
    chiller_capacity_for_rent_unit: null,
    chiller_deposit: null,
    expenses: null,
    expected_rent: null,
    rent_targeted_price: null,
    rent_price_fees: null,
    rent_roi: null,
    unit_images: null,
    unit_documents_files: null,
    data_completed: 16,
    rent_listing_agent: null,
    lease_lead_owner: null,
    sale_type: null,
  });

  const [saveDtoRent, setSaveDtoRent] = useState({
    unit_ref_no: null,
    unit_type_id: 1,
    operation_type: {
      lookupItemId: 431,
      lookupItemName: "Rent",
      lookupItemCode: null,
      description: null,
      order: 2,
      parentLookupItemId: null,
      parentLookupItemName: null,
      parentLookupTypeId: 0,
      parentLookupTypeName: null,
      isEditable: false,
    },
    new_unit: null,
    unit_type: null,
    furnished: "No",
    property_name: null,
    owner: null,
    lead_owner: null,
    floor_number: null,
    mandates: null,
    mandate_type: null,
    unit_number: null,
    mortgaged: null,
    can_view: null,
    unique_selling_proposition_usp: null,
    municipality_number: null,
    ejari_approval_refno: null,
    inventory_list_from: null,
    website_unit_link: null,
    fully_unit_description: null,
    unit_model: null,
    full_floor: null,
    bedrooms: null,
    bathrooms: null,
    maid_rooms: null,
    store_room: null,
    study_room: null,
    kids_breakfast_room: null,
    kitchen_details: null,
    number_of_balcony: null,
    number_of_terraces: null,
    floor_height: null,
    plot_area_sqft: null,
    builtup_area_sqft: null,
    gfa_sqft: null,
    balcony_area_size_sqft: null,
    terrace_size_sqft: null,
    total_area_size_sqft: null,
    price_per_sqm: null,
    amenities: null,
    fitting_and_fixtures: null,
    primary_view: null,
    secondary_view: null,
    pets_allowed: null,
    rating: null,
    listing_agent: null,
    listing_date: null,
    listing_expiry_period: null,
    listing_expiry_date: null,
    last_available_for_rent: null,
    market_value_rent: null,
    rent_security_deposit: null,
    rent_general_deposit: null,
    chiller_charge_type: null,
    chiller_charge_for_rent_unit: null,
    chiller_capacity_for_rent_unit: null,
    chiller_deposit: null,
    expenses: null,
    expected_rent: null,
    rent_targeted_price: null,
    rent_price_fees: null,
    rent_roi: null,
    unit_images: null,
    unit_documents_files: null,
    data_completed: 16,
    lease_lead_owner: null,
    rent_listing_agent: null,
  });

  const AddContactOnSaveHandler = () => {
    setOnSaveCall(true);
  };
  const saveAndCompleteDetailsHandler = () => {
    setOnSaveAndCompleteCall(true);
  };

  useEffect(() => {
    setSaveDtoRent((item) => ({
      ...item,
      unit_number: addNewUnit?.unit?.unitNumber,
      unit_type: addNewUnit?.unit?.unitType,
      property_name: addNewUnit?.unit?.propertyName,
    }));
  }, [addNewUnit]);

  return (
    <CustomDialog
      open={open}
      width="1024px"
      title={translate("Add-new-unit")}
      subtitle={translate(
        "Fill-in-the-details-below-to-add-a-new-unit-to-your-list-Ensure-all-required-fields-are-completed-before-saving"
      )}
      confirmText={translate("Add-unit")}
      contentDialogClass={styles.containerContentDialog}
      cancelText={translate("cancel")}
      onClose={() => onClose()}
      onConfirm={() => {
        AddContactOnSaveHandler();
      }}
      isDisabled={(view === 1 && !saveDtoSale?.sale_type) || onSaveCall}
      content={
        view === 2 ? (
          <>
            <UnitsAddForRentView
              setview={(viewval) => setview(viewval)}
              onClose={() => onClose()}
              onSaveCall={onSaveCall}
              onSaveAndCompleteCall={onSaveAndCompleteCall}
              saveDto={saveDtoRent}
              setSaveDto={setSaveDtoRent}
            />
          </>
        ) : (
          <>
            <UnitsAddForSaleView
              setview={(viewval) => setview(viewval)}
              onClose={() => onClose()}
              onSaveCall={onSaveCall}
              onSaveAndCompleteCall={onSaveAndCompleteCall}
              saveDto={saveDtoSale}
              setSaveDto={setSaveDtoSale}
            />
          </>
        )
      }
      moreAction={
        <CustomButton
          boxShadow="none"
          size="lg"
          variant="text"
          color="tertiaryGray"
          onClick={() => {
            saveAndCompleteDetailsHandler(true);
          }}
          style={{ marginInlineEnd: "auto" }}
        >
          {translate("Save-And-Complete-Details")}
        </CustomButton>
      }
    />
  );
};

export default UnitSucsessValidateDialog;
